import { useState, useRef } from 'react';
import { Box, Button, Typography, MenuItem, TextField, LinearProgress } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { uploadDocument } from '../api/documents';

const TYPES = [
    { value: 'TITRE_FONCIER',  label: 'Titre foncier' },
    { value: 'PLAN_CADASTRAL', label: 'Plan cadastral' },
    { value: 'ACTE_VENTE',     label: 'Acte de vente' },
    { value: 'PHOTO_TERRAIN',  label: 'Photo du terrain' },
    { value: 'CNI_VENDEUR',    label: 'CNI du vendeur' },
    { value: 'CNI_ACHETEUR',   label: "CNI de l'acheteur" },
    { value: 'AUTRE',          label: 'Autre' },
];

export default function DocumentUpload({ dossierId, onUpload }) {
    const inputRef          = useRef();
    const [file,     setFile]     = useState(null);
    const [type,     setType]     = useState('AUTRE');
    const [loading,  setLoading]  = useState(false);
    const [progress, setProgress] = useState(0);

    const handleFile = (e) => setFile(e.target.files[0]);

    const handleUpload = async () => {
        if (!file) return;
        setLoading(true);
        const formData = new FormData();
        formData.append('fichier',       file);
        formData.append('dossier',       dossierId);
        formData.append('type_document', type);
        formData.append('nom',           file.name);
        try {
            await uploadDocument(formData);
            setFile(null);
            setProgress(0);
            inputRef.current.value = '';
            onUpload?.();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{
            border: '2px dashed #1a3c5e40', borderRadius: 2,
            p: 2, textAlign: 'center', mb: 1,
        }}>
            <input type="file" hidden ref={inputRef} onChange={handleFile}
                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" />

            {!file ? (
                <Box>
                    <CloudUpload sx={{ fontSize: 40, color: '#1a3c5e60' }} />
                    <Typography variant="body2" color="text.secondary" mb={1}>
                        PDF, images, documents Word
                    </Typography>
                    <Button variant="outlined" size="small" onClick={() => inputRef.current.click()}>
                        Choisir un fichier
                    </Button>
                </Box>
            ) : (
                <Box>
                    <Typography variant="body2" fontWeight={600} mb={1}>
                        📄 {file.name}
                    </Typography>
                    <TextField select size="small" value={type}
                        onChange={(e) => setType(e.target.value)}
                        sx={{ mb: 1, width: '100%' }} label="Type de document">
                        {TYPES.map(t => (
                            <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>
                        ))}
                    </TextField>
                    {loading && <LinearProgress value={progress} sx={{ mb: 1 }} />}
                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                        <Button size="small" onClick={() => { setFile(null); inputRef.current.value = ''; }}>
                            Annuler
                        </Button>
                        <Button size="small" variant="contained" onClick={handleUpload} disabled={loading}>
                            Uploader
                        </Button>
                    </Box>
                </Box>
            )}
        </Box>
    );
}